const seoPages = [
  {
    name: "tenant_background_check",
    path: "/tenant-background-check",
    meta: {
      main: "Run Background Checks",
      highlight: "On Your Tenants"
    }
  },
  {
    name: "tenant_screening",
    path: "/tenant-screening",
    meta: {
      main: "Easy Online",
      highlight: "Tenant Screening",
      sub: "Instant, Automated Tenant Screening Services -- Get Started In 5 Minutes"
    }
  },
  {
    name: "tenant_credit_check",
    path: "/tenant-credit-check",
    meta: {
      main: "Need Credit Reports",
      highlight: "For Tenants?",
      sub: "Rent Application Has You Covered"
    }
  },
  {
    name: "online_rental_application",
    path: "/online-rental-application",
    meta: {
      main: "Online Rental ",
      highlight: "Applications",
      sub: "Customizable. Mobile Friendly. Automatic Tenant Screening."
    }
  },
  {
    name: "online_apartment_application",
    path: "/online-apartment-application",
    meta: {
      main: "Online Apartment ",
      highlight: "Applications",
      sub: "Customizable. Mobile Friendly. Automatic Tenant Screening."
    }
  },
  {
    name: "landlord_forms",
    path: "/landlord-forms",
    meta: {
      main: "Landlord Forms",
      sub: "Customize Your Own Rental Application Form For Screening Tenants"
    }
  },
  {
    name: "landlord_tenant_forms",
    path: "/landlord-tenant-forms",
    meta: {
      main: "Landlord Tenant Forms",
      sub: "Need A Rental Application Form For Screening Tenants? Use Our Template Or Customize Your Own"
    }
  },
  {
    name: "forms_for_landlords",
    path: "/forms-for-landlords",
    meta: {
      main: "Forms For Landlords",
      sub: "Looking For A Rental Application Form For Screening Tenants? Use Our Proven Template Or Customize Your Own."
    }
  },
  {
    name: "alt",
    path: "/alt",
    meta: {
      main: "Landlords, Screen Your Tenants.",
      highlight: "Fast."
    }
  },
  {
    name: "condo.com",
    path: "/condo.com",
    meta: {
      main: "Forms For Landlords",
      sub: "Looking For A Rental Application Form For Screening Tenants? Use Our Proven Template Or Customize Your Own."
    }
  },
  {
    name: "fill_your_vacancies",
    path: "/fill-your-vacancies",
    meta: {
      main: "Fill Your Vacancies Faster",
      highlight: "With Perfect Tenants",
      sub: "Build Your Own Customized Online Rental Application Form -- Get Started In 5 Minutes"
    }
  }
]

export default seoPages
